module.exports = require("core-js/modules/esnext.map.update.js");